import React from 'react';
import { useCurrency } from '../../context/CurrencyContext';

/**
 * <Price basePriceEUR={20} suffix="/hr" />
 * <Price basePriceEUR={49} suffix="/mo" size="lg" />
 * Automatically converts using the active currency + live rates.
 */
export default function Price({ basePriceEUR, suffix, size = 'md', className = '', testid, showBase = false }) {
  const { format, currency } = useCurrency();
  const value = format(basePriceEUR, { suffix });

  const sizeCls = size === 'lg' ? 'text-3xl sm:text-4xl' : size === 'sm' ? 'text-sm' : 'text-lg';

  return (
    <span className={`inline-flex items-baseline gap-1 ${className}`} data-testid={testid || 'price'}>
      <span className={`font-bold text-[#1A2F4A] ${sizeCls}`} style={{ fontFamily: "'Playfair Display', serif" }}>
        {value}
      </span>
      {showBase && currency !== 'EUR' && (
        <span className="text-[10px] text-[#6B4E37]/70 italic">
          (€{basePriceEUR.toFixed(2)}{suffix || ''})
        </span>
      )}
    </span>
  );
}
